import { render, staticRenderFns } from "./LgFinderPageImpressora.vue?vue&type=template&id=5fb7d7cd"
import script from "./LgFinderPageImpressora.vue?vue&type=script&lang=js"
export * from "./LgFinderPageImpressora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports